import { render, staticRenderFns } from "./teams.vue?vue&type=template&id=3d10507e&"
import script from "./teams.vue?vue&type=script&lang=js&"
export * from "./teams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports